// extracted by mini-css-extract-plugin
module.exports = {"notifications-drawer":"notifications-content_notifications-drawer__gmAO_"};